import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Boton from "../boton/Boton";
import Error from "../generales/Error";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const FormularioLogin = ({ loginUsuarios, setLoginUsuarios }) => {
  const [error, setError] = useState(false)

  function IniciarSesion(e) {
    e.preventDefault();
    var email = document.getElementById("email").value;
    var password = document.getElementById("password").value;
    if (email === 0 && password === 0) {
      alert("usuario y/o contraseña incorrecta");
    }
  }

  const navigate = useNavigate();

  const usuarioRegistradoSchema = Yup.object().shape({
    email: Yup.string()
      .email("Correo electrónico No válido")
      .required("El correo electrónico es obligatorio"),
    password: Yup.string()
      .required("La contraseña es obligatoria")
      .min(3, "tienes 3 intentos para ingresar tu contraseña"),
  });

  const handleSubmit = async (valores) => {
    //Axios
    try {
      const url = "https://mymoney5.herokuapp.com/auth/signin";

      const { status, data } = await axios.post(url, valores);
      if (status === 200) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("id", data.id);
      }

      navigate("/home");
    } catch (error) {
      setError(true);
      return
    }
  };
  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      onSubmit={(values) => {
        handleSubmit(values);
      }}
      validationSchema={usuarioRegistradoSchema}
    >
      {({ errors, touched }) => {
        return (
          <Form>
            <div className="formulario-input">
              <label htmlFor="email">Correo electrónico</label>
              <Field
                id="email"
                type="email"
                placeholder="Correo electrónico"
                name="email"
                required
              />
              {errors.email && touched.email ? (
                <Error>{errors.email}</Error>
              ) : null}
            </div>
            <div className="formulario-input">
              <label htmlFor="password">Contraseña</label>
              <Field
                id="password"
                type="password"
                placeholder="Contraseña"
                name="password"
                required
              />
              {errors.password && touched.password ? (
                <Error>{errors.password}</Error>
              ) : null}
            </div>
            <Boton> Iniciar sesión </Boton>

            {error && (
              <div className="formulario-error">
                <p>Ocurrio un error, intenta de nuevo</p>
              </div>
            )}

          </Form>
        );
      }}
    </Formik>
  );
};

export default FormularioLogin;
